import { styled } from '@biome-design-system/styles';
import { fromTheme } from '@kyruus/ui-theme';
import { ListItem as BaseListItem } from '@biome-design-system/ui/ListItem';
import { ListItemButton as BaseListItemButton } from '@biome-design-system/ui/ListItemButton';
import { ListItemText as BaseListItemText } from '@biome-design-system/ui/ListItemText';
import { OpenInNewIcon as BaseOpenInNewIcon } from '@biome-design-system/icons/OpenInNewIcon';
import { List as BaseList } from '@biome-design-system/ui/List';

export const Header = styled('div')`
  position: sticky;
  top: 0;
  height: 60px;

  z-index: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: ${fromTheme('color_background')};
  border-bottom: 1px solid ${fromTheme('color_border')};
  padding: 0 ${fromTheme('spacing_large')};

  & h2 {
    font-size: ${fromTheme('font_size_heading_4')};
    font-weight: ${fromTheme('font_weight_bolder')};
  }
`;

export const List = styled(BaseList)`
  height: 100vh;
  overflow-y: auto;
`;

export const ListItem = styled(BaseListItem)`
  height: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ListItemButton = styled(BaseListItemButton)`
  height: 100%;
  padding: 0px ${fromTheme('spacing_large')};
  justify-content: space-between;
`;

export const ListItemText = styled(BaseListItemText)`
  margin: 0;
  & .MuiListItemText-primary {
    line-height: ${fromTheme('font_line_height')};
    font-size: ${fromTheme('font_size_heading_5')};
    font-weight: ${fromTheme('font_weight_bold')};
  }
  & .MuiListItemText-secondary {
    line-height: ${fromTheme('font_line_height')};
    color: ${fromTheme('color_text')};
    font-size: ${fromTheme('font_size')};
    font-weight: ${fromTheme('font_weight')};
  }
`;

export const OpenInNewIcon = styled(BaseOpenInNewIcon)`
  color: ${fromTheme('color_text')};
  box-sizing: border-box;
  padding: ${fromTheme('spacing_small')};
`;

export const PhoneNumber = styled('span')`
  font-weight: ${fromTheme('font_weight')};
  padding-left: ${fromTheme('spacing_small')};
`;
